export function getUnleashFeatureWithPodletPrefix(nameId: string): string {
    return 'displayads-podlet-horseshoe.' + nameId;
}

export const UNLEASH_FEATURE_NAMES = {
    // Server features
    killSwitch: 'killswitch.banners',
    appNexus9826: 'appNexus9826',
    astFallback: 'ast.fallback',
    enableTransparencyCogwheel: 'enableTransparencyCogwheel',
    EAad: 'EAad',

    // Client features
    enableAdIntervalVariant: 'enableAdIntervalVariant',
    enableRelevantDigitalAd: 'enableRelevantDigitalAd',
    enableFixedHorseshoe: 'enableFixedHorseshoe',
    enableDisplayAdsDebugger: 'enableDisplayAdsDebugger',

    // Client experiments
    objectPageInScreenExperiment: 'objectPageInScreenExperiment',
    enableTopBannerThreshProx: 'enableTopBannerThreshProx',
    enableSearchFirstResultHalfProx: 'enableSearchFirstResultHalfProx',
    largeFontSizeContentMarketingExperiment: 'fontExperiment8A',
};
